import style from './maintenance.module.css'
import logo from '../../assets/images/Logotipo003.png'
export function MaintenancePage(){
    return (
        <div className={style.Page}>
            <img id={style.LogoImage} src={logo} alt='Logo' />
            <h1 id={style.Title}>Em Construção</h1>
        </div>
    )
}